/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import PasswordRepository from 'repositories/auth/PasswordRepository';

const initialState = {
  passwordUpdatingStatus: FETCH_STATUSES.idle,
};

const updatePasswordSlice = createSlice({
  name: 'updatePasswordSlice',
  initialState,
  reducers: {
    updatePasswordStart(state) {
      state.passwordUpdatingStatus = FETCH_STATUSES.pending;
    },
    updatePasswordFinish(state) {
      state.passwordUpdatingStatus = FETCH_STATUSES.fulfilled;
    },
    updatePasswordFail(state) {
      state.passwordUpdatingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = updatePasswordSlice;

export default updatePasswordSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const updatePassword = async (attrs, queryParams) => {
    dispatch(actions.updatePasswordStart());
    try {
      await PasswordRepository.updatePassword(attrs, queryParams);
      dispatch(actions.updatePasswordFinish());
      return Promise.resolve();
    } catch (error) {
      dispatch(actions.updatePasswordFail());
      throw error;
    }
  };

  return {
    updatePassword,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/auth/updatePasswordSlice.js